import axios from "axios";
// Dashboard Data API
export const CustomerManagementData = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "BUILDING_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/customer`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "BUILDING_DATA_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "BUILDING_DATA_FAILURE",
      payload: error.message,
    });
  }
};
// Delete Data API
export const deleteCustomer = (id) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const url = `${process.env.REACT_APP_API_URL}/customer/${id}`;

  dispatch({ type: "DELETE_CUSTOMER_REQUEST", payload: id });

  try {
    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "DELETE_CUSTOMER_SUCCESS",
      });
      dispatch(CustomerManagementData());
    } else {
      dispatch({
        type: "DELETE_CUSTOMER_FAIL",
      });
    }
  } catch (error) {
    console.error("Failed to delete customer:", error);
    dispatch({
      type: "DELETE_CUSTOMER_FAIL",
      payload:
        error?.response?.data?.message || error.message || "Unknown error",
    });
  }
};

// Add Data APi
export const addCustomer = (formData) => async (dispatch) => {
  dispatch({ type: "ADD_CUSTOMER_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/customer`;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "ADD_CUSTOMER_SUCCESS",
        payload: response.data,
      });
    } else {
      dispatch({ type: "ADD_CUSTOMER_FAIL" });
      dispatch(setToastMessage("Failed to add device"));
    }
  } catch (error) {
    console.error("Failed to add device:", error);

    dispatch({
      type: "ADD_CUSTOMER_FAIL",
      payload:
        error?.response?.data || error.message || "Unknown error",
    });
  }
};
export const editCustomer = (id, formDataToSend) => async (dispatch) => {
  dispatch({ type: "EDIT_CUSTOMER_REQUEST" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/customer/${id}`;

    const response = await axios.put(url, formDataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: "EDIT_CUSTOMER_SUCCESS",
      payload: response.data,
    });

  } catch (error) {
    console.error("Failed to add device:", error);
    dispatch({
      type: "EDIT_CUSTOMER_FAILURE",
      payload: error?.response?.data || {},
    });

  }
};
export const setToastMessage = (message) => ({
  type: "SET_TOAST_MESSAGE",
  payload: message,
});

export const setToastOpen = (isOpen) => ({
  type: "SET_TOAST_OPEN",
  payload: isOpen,
});

export const fetchOnSelectionData = (data) => ({
  type: "MAP_DATA",
  payload: data,
});
export const markerAction = (data) => ({
  type: "MAP_MARKER_DATA",
  payload: data,
});

export const resestMarkFeild = () => ({
  type: "RESET_MARKER_DATA",
});

export const customerDataAction = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "CUSTOMER_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/customer`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "CUSTOMER_DATA_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "CUSTOMER_DATA_FAILURE",
      payload: error.message,
    });
  }
};

